export function openViewCharge(){
	document.getElementById('screenBlackAll').style.display = "";
	document.getElementById('carga').style.display = "";
}

export function closeViewCharge(){
	document.getElementById('screenBlackAll').style.display = "none";
	document.getElementById('carga').style.display = "none";
}
